let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("hsB1k"), load("e12DM")]).then(() => parcelRequire('l1b8J'));